module.exports = __webpack_public_path__ + "media/images/icons/outlined/apartment-a6f8bfcf6affe02f9ec7f00dfcf303e0.svg";